import type { OperationType } from '@acceligentllc/shared/enums/operation';
import { QuantityUnitLabel } from '@acceligentllc/shared/enums/quantityUnit';
import type { QuantityUnitType } from '@acceligentllc/shared/enums/quantityUnit';
import * as ReportBlockFieldEnum from '@acceligentllc/shared/enums/reportBlockField';

import type { ReportBlockFieldFormModel, CalculatedFieldOptionFormModel } from '../formModel';
import { OPERATION_TYPE_FILTER } from '../formModel';

export const filterByOperationType = (option: ReportBlockFieldFormModel, operation: Nullable<OperationType>) => {
	return !!operation && OPERATION_TYPE_FILTER[operation](option);
};

/**
 * Function that filters by selected fields
 * If field is not already selected or if selected make sure option index is equal to selected index
 */
export const filterBySelectedFields = (
	option: ReportBlockFieldFormModel,
	selectedUnit: Nullable<QuantityUnitType>,
	selectedFieldsMap: { [key: string]: number; },
	index: number
) => {
	return (!(selectedFieldsMap[option.virtualId] !== undefined) || selectedFieldsMap[option.virtualId] === index)
		&& (selectedUnit === option.unit || !selectedUnit || !option.unit);
};

/**
 * Function that returns filter function for filtering options in Calculated Field Modal
 * @param operation selected operation type
 * @param unit unit of already selected field
 * @param selectedFieldsMap map of already selected fields
 * @param additionalFilter optional additional filter functions
 * @returns filter function
 */
export const getOptionFieldFilter = (
	operation: Nullable<OperationType>,
	unit: Nullable<QuantityUnitType>,
	selectedFieldsMap: { [key: string]: number; },
	fieldsByIdMap: { [fieldId: string]: ReportBlockFieldFormModel; },
	additionalFilter?: (option: ReportBlockFieldFormModel) => boolean
) => {
	return (option: CalculatedFieldOptionFormModel, index: number) => {
		return option.id && filterByOperationType(fieldsByIdMap[option.id], operation)
			&& filterBySelectedFields(fieldsByIdMap[option.id], unit, selectedFieldsMap, index)
			&& (additionalFilter?.(fieldsByIdMap[option.id]) ?? true);
	};
};

export const getOptionLabel = (option: ReportBlockFieldFormModel) => {
	const fieldType = ReportBlockFieldEnum.PrimaryTypeNamed[option.fieldType] ?? '';
	const unit = option.unit ? QuantityUnitLabel[option.unit] : '';
	return `${fieldType} ${unit ? `[${unit}]` : ''}`;
};
